// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1U6Zi","header":"PatientBlock_header__1cJxc","label":"PatientBlock_label__1i9QS","option":"PatientBlock_option__1yjHd"};